import React from "react";

import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";

interface IProps {
  title: string;
}

const containerSX = {
  bgcolor: (theme: any) => theme.palette.background.paper,
  boxShadow: "0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)",
} as const;

export const WrapperWithTitle: React.FC<IProps> = (props) => (
  <Grid container spacing={1} ml={0} p={3} sx={containerSX}>
    <Grid item xs={12}>
      <Typography fontWeight={600}>{props.title}</Typography>
    </Grid>
    <Grid item xs={12}>
      {props.children}
    </Grid>
  </Grid>
);
